module.exports = __webpack_public_path__ + "img/schets-1.2aa06343.jpg";